export default __webpack_public_path__ + "static/media/foto_03.1c3b2099.jpg";